"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function RrcuratedsnapshotsMulticolorOutlineMulticolorOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 17 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__rrcuratedsnapshots-multicolor-outline-multicolor-outline__clip0_16352_4036)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCE5FF",
    d: "M8.014 12.02a4.021 4.021 0 100-8.043 4.021 4.021 0 000 8.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.523 7.974L8.018 9.618 5.51 7.978l-.553.348.549.36 2.512 1.665 2.06-1.353.449-.296.548-.36-.552-.368zm2.745 1.748l-.553-.352-.552-.352-.548.36-3.6 2.353-3.602-2.353-.552-.36-.556.352-.556.352-1.64 1.029 6.91 4.517 6.889-4.513-1.64-1.033zM2.217 10.775l1.088-.689 4.713 3.065 4.701-3.085 1.085.693-5.786 3.789-5.801-3.773z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADB5BD",
    d: "M13.82 9.362l-.557-.352-.556-.356-.548.364-.548.36.552.352.556.352 1.084.693-5.785 3.789-5.801-3.79 1.088-.688.556-.356.556-.352-.552-.36-.552-.364-.556.356-.556.352L0 10.751l8.002 5.241 8.002-5.237-2.185-1.393zm-2.745-1.748l-.556-.356-2.501 1.64-2.18-1.424-.153-.096H5.33l-.376.236-.552.352.552.36.548.36 2.517 1.665 2.06-1.353.449-.296.548-.36.552-.36-.552-.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.268 6.89l-.525-.348-1.64 1.076-.552.36-2.505 1.644-2.508-1.64-.553-.364-1.644-1.076-.548.348-1.684 1.06L2.74 9.01l.552.36.552.36 4.157 2.721 4.145-2.72.548-.36.549-.36 1.664-1.061-1.64-1.06zm-.56 1.764l-.549.364-.548.36-3.6 2.353-3.602-2.353-.552-.36-.552-.364-1.088-.704 1.088-.688 1.096.688.552.36.549.36 2.516 1.68 2.06-1.352.449-.296.548-.36.552-.36 1.092-.716 1.085.684-1.097.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.018 10.35L5.501 8.71l2.517 1.64 2.06-1.352-2.06 1.353zm5.801-3.8l-1.108-.709-.324.212-1.868 1.225-2.501 1.64-2.18-1.424-2.201-1.44-.324-.213L2.2 6.55 0 7.946l2.2 1.436.553.36.552.364 4.713 3.045 4.701-3.085.548-.36.553-.36 2.192-1.436-2.193-1.36zm-1.66 2.488l-.548.36-3.601 2.353-3.6-2.353-.553-.36-.552-.364-1.088-.724 1.088-.688L4.4 7.95l.552.36.548.36 2.517 1.68 2.06-1.352.449-.296.548-.36.552-.36 1.092-.716 1.085.684-1.097.716-.548.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M16.012 5.093L13.82 6.53l-.553.36-.224.148-.324-.5h-.004l-.328-.504.324-.213 1.089-.716L8.022 1.42 2.217 5.105l1.096.716.324.213-.328.504h-.004l-.324.5-.228-.148-.552-.36L.004 5.093 4.91 1.976 8.026 0l7.986 5.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADB5BD",
    d: "M8.026 0L4.909 1.976 0 5.09l2.197 1.437.552.36.228.148.324.212 1.1.704.552.36.548.36 2.517 1.64 2.06-1.348.449-.296.548-.36.552-.36 1.092-.716.324-.212.224-.148.553-.36 2.192-1.437L8.026 0zm4.361 6.034L10.52 7.258l-2.501 1.64-2.18-1.424-2.201-1.44-.324-.213-1.096-.716L8.022 1.42l5.777 3.685-1.088.716-.324.213z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__rrcuratedsnapshots-multicolor-outline-multicolor-outline__clip0_16352_4036"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16.012V16H0z"
  }))));
}

RrcuratedsnapshotsMulticolorOutlineMulticolorOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
RrcuratedsnapshotsMulticolorOutlineMulticolorOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = RrcuratedsnapshotsMulticolorOutlineMulticolorOutline;
exports["default"] = _default;